import service from '@/base/service'

const baseURL = process.env.VUE_APP_BASE_API_AI
const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}

const requestL = (data) => {
  // : '/local'
  return service({ ...data, ...{ baseURL } })
}

//  获取产业分类
export function getClassify(data) {
  return request({
    url: '/industryChain/classify',
    method: 'get',
    params: data
  })
}

//  模糊搜索产业链
export function getIndustryChainFuzzy(data) {
  return request({
    url: '/industryChain/fuzzy',
    method: 'post',
    data
  })
}

//  根据产业链名称获取产业链关系
export function getChains(data) {
  return request({
    url: '/industryChain/chain',
    method: 'get',
    params: data
  })
}

//  根据产业链和产品名获取公司信息
export function getChainCompanies(data) {
  return request({
    url: '/industryChain/chainCompany',
    method: 'post',
    data
  })
}



//  根据公司名查询股东信息
export function getChainPersons(data) {
  return request({
    url: '/industryChain/companyPerson',
    method: 'post',
    data
  })
}

// 热门机构及事件
export function getNewsStat(data) {
  return request({
    url: '/productCustomer/news/chain/stat',
    method: 'post',
    data
  })
}

// 政策高频词、区域分布
export function getPolicyStat(data) {
  return request({
    url: '/productCustomer/policy/chain/stat',
    method: 'post',
    data
  })
}

// 企业分布
export function getDistribution(data) {
  return requestL({
    url: '/productCustomer/enterprise/distribution',
    method: 'post',
    data
  })
}


// 产业新闻
export function getNewsPage(data) {
  return request({
    url: '/productCustomer/news/page',
    method: 'post',
    data
  })
}

// 产业政策
export function getPolicyChain(data) {
  return request({
    url: '/productCustomer/policy/chain',
    method: 'post',
    data
  })
}

// 产业获客-产业链-头部企业
export function getChainTopCompany(data) {
  return requestL({
    url: '/productCustomer/chain/top/company',
    method: 'post',
    data
  })
}


// 产业链图谱
export function getIndustryChain(data) {
  return requestL({
    url: '/industry/industryChain',
    method: 'post',
    data
  })
}

// 趋势分析
export function getChainAnalysis(data) {
  return requestL({
    url: '/productCustomer/analysis',
    method: 'post',
    data
  })
}


// 政策类型
export function getPolicyType(data) {
  return requestL({
    url: '/productCustomer/policy/type',
    method: 'get',
    data
  })
}


// 政策结构名称
export function getPolicyDept(data) {
  return requestL({
    url: '/productCustomer/policy/dept',
    method: 'get',
    params: data
  })
}

// 关键词的下拉联想
export function getPolicyKeyword(data) {
  return requestL({
    url: '/productCustomer/policy/keyword',
    method: 'get',
    params: data
  })
}

